import React, {useCallback, useRef, useState} from 'react'
import {withTranslation} from "react-i18next";

import BButton from 'components/Form/Fields/BButton'
import Product from 'components/ProductsList/Product'
import Suggestions from 'components/ProductsList/Suggestions'
import Categories from 'components/ProductsList/Categories'
import requestHandler from 'utils/requestHandler'

const ProductsList = ({t, mode, items, loadMoreRequest, setData, handleSearch, searchValue}) => {
  const [loadingMore, setLoadingMore] = useState(false)

  const page = useRef(0)

  const handleLoadMore = useCallback(e => {
    e.preventDefault()
    setLoadingMore(true)
    requestHandler(() => loadMoreRequest(page.current + 1), 'json')
      .then(r => {
        if (r.success) {
          setData(({items}) => ({items: {...items, metaProduct: {...items.metaProduct, ...r.data.items.metaProduct}}}))
          page.current = page.current + 1
        }
        setLoadingMore(false)
      })
  }, [setData, loadMoreRequest])

  return (
    <div className='productsList'>
      {items.metaProduct ? (
        <>
          {mode === 'fullSearchResults' ? (
            <h1 className='productsList-fullSearchResultsHeading'>{t('You\'re looking for')} <b>"{searchValue}"</b></h1>
          ) : mode === 'categoryItems' ? (
            <>
              <h1 className='productsList-fullSearchResultsHeading'>{searchValue}</h1>
              <h3 className='productsList-secondaryHeading'><b>{items.count} {t('products')}</b> {t('in this category')}</h3>
            </>
          ) : (
            <Suggestions t={t} suggestions={items.suggestions} handleSearch={handleSearch} searchValue={searchValue}/>
          )}

          <Categories t={t} categories={items.categories} mode={mode}/>

          <div className='productsList-theList'>
            {mode === 'autocomplete' && <h4>We found products</h4>}
            <div>
              {Object.keys(items.metaProduct).map(e => <Product key={e} product={items.metaProduct[e]}/>)}
            </div>
            {loadingMore ? 'loading more...' : <BButton onClick={handleLoadMore}>Load more...</BButton>}
          </div>
        </>
      ) : (
        'no items found'
      )}
    </div>
  )
}

export default withTranslation()(ProductsList)
